import { Box, BoxProps } from '@mui/material';
import React from 'react';
import ekkoLogo from 'src/assets/images/ekko_logo_dark.png';

interface Props extends Omit<BoxProps, 'color' | 'width' | 'height'> {
  width: number | string;
  height: number | string;
  /** Theme color token (e.g. 'text.primary') or any CSS color to paint it. */
  color?: string;
}

/**
 * The Ekko logo, recolored to a theme token so it adapts to light/dark mode.
 * The logo PNG is used purely as a CSS mask (its alpha shape) and the color
 * comes from `backgroundColor`, so a single asset works at any size/color
 * (the baked-in color of the source PNG is irrelevant). It has a transparent
 * background.
 *
 * forwardRef + prop spread so it stays a drop-in child for MUI Tooltip etc.
 */
export const EkkoLogo = React.forwardRef<HTMLDivElement, Props>(
  ({ width, height, color = 'text.primary', sx, ...rest }, ref) => (
    <Box
      ref={ref}
      role={'img'}
      aria-label={'ekko'}
      {...rest}
      sx={{
        width,
        height,
        backgroundColor: color,
        WebkitMaskImage: `url(${ekkoLogo})`,
        maskImage: `url(${ekkoLogo})`,
        WebkitMaskRepeat: 'no-repeat',
        maskRepeat: 'no-repeat',
        WebkitMaskPosition: 'center',
        maskPosition: 'center',
        WebkitMaskSize: 'contain',
        maskSize: 'contain',
        ...sx,
      }}
    />
  ),
);

EkkoLogo.displayName = 'EkkoLogo';
